import AnimeLoader from '@/app/assets/svg/anime-loader.svg?react';
import CheckmarkIcon from '@/app/assets/svg/checkmark.svg?react';
import CloseIcon from '@/app/assets/svg/close.svg?react';
import { cn } from '@/app/shared/lib/cn';

export enum StepStatus {
  Pending = 'pending',
  AwaitingWallet = 'awaiting_wallet',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export interface StepIconProps {
  status: StepStatus;
}

const squareClass = 'flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-md';

const StepIcon = ({ status }: StepIconProps) => {
  if (status === StepStatus.Success) {
    return (
      <div className={cn(squareClass, 'bg-modal-step-success text-white')}>
        <CheckmarkIcon className='h-6 w-6' />
      </div>
    );
  }

  if (status === StepStatus.Error) {
    return (
      <div className={cn(squareClass, 'bg-feedback-error text-white')}>
        <CloseIcon className='h-6 w-6' />
      </div>
    );
  }

  if (status === StepStatus.Loading || status === StepStatus.AwaitingWallet) {
    return (
      <div className={cn(squareClass, 'bg-modal-step-loader-bg text-modal-step-loader-color')}>
        <AnimeLoader className='h-6 w-6' />
      </div>
    );
  }

  return <div className={cn(squareClass, 'bg-modal-step-loader-bg opacity-40')} />;
};

export default StepIcon;
